import { emptyOrNonProvisionedStatusUpdateStateRoute } from '@townsquare/routes/empty-or-non-provisioned-status-update-state';
import { titanEapCrossFlowQueryResource } from '@townsquare/titan-eap-cross-flow/resource';

import { StatusUpdatesView } from './ui/StatusUpdates/StatusUpdatesView';

emptyOrNonProvisionedStatusUpdateStateRoute.component = StatusUpdatesView;
emptyOrNonProvisionedStatusUpdateStateRoute.resources = [titanEapCrossFlowQueryResource];
export const emptyOrNonProvisionedStatusUpdateStateRouterRoute = emptyOrNonProvisionedStatusUpdateStateRoute;
